// src/routes/categoriesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Categories from '../pages/categories/Categories';
import CreateCategory from '../pages/categories/CreateCategory';
import EditCategory from '../pages/categories/EditCategory';
import ProtectedRoute from '../components/global/ProtectedRoute';

const categoriesRoutes = (
    <>
        {/* Categories List */}
        <Route
            path="/categories"
            element={
                <ProtectedRoute requiredPermission="categories_list">
                    <Categories />
                </ProtectedRoute>
            }
        />

        {/* Categories Archive */}
        <Route
            path="/categories/archive"
            element={
                <ProtectedRoute requiredPermission="categories_archive_list">
                    <Categories />
                </ProtectedRoute>
            }
        />

        {/* Create Category */}
        <Route
            path="/categories/create"
            element={
                <ProtectedRoute requiredPermission="categories_create">
                    <CreateCategory />
                </ProtectedRoute>
            }
        />

        {/* Edit Category */}
        <Route
            path="/categories/:id/edit"
            element={
                <ProtectedRoute requiredPermission="categories_edit">
                    <EditCategory />
                </ProtectedRoute>
            }
        />
    </>
);

export default categoriesRoutes;
